/**
 * @param totalTokenAmount - sum of balance and lockedBalance in user wallet
 * @param amount
 * @returns boolean
 */
export const hasEnoughToken =
	(totalTokenAmount: number) =>
	(amount: number | string): boolean => {
		if (isNaN(Number(amount))) {
			amount = 0;
		}

		return Number(amount) <= totalTokenAmount;
	};
